import React, { useState, useEffect } from 'react';
import { MdArrowBack, MdSecurity, MdCheckCircle } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // i18n hook import kiya
import { db } from "../firebase";
import { ref, set, onValue } from "firebase/database";
import Swal from 'sweetalert2';
import './PaymentMethod.css';

const PaymentMethod = () => {
    const { t } = useTranslation(); // Translation function initialize kiya
    const [walletName, setWalletName] = useState('');
    const [address, setAddress] = useState('');
    const [isBound, setIsBound] = useState(false);
    const [loading, setLoading] = useState(true);
    
    const navigate = useNavigate();
    const savedUser = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (savedUser?.username) {
            const walletRef = ref(db, `users/${savedUser.username}/paymentMethod`);
            onValue(walletRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setWalletName(data.walletName);
                    setAddress(data.address);
                    setIsBound(true);
                }
                setLoading(false);
            });
        }
    }, [savedUser?.username]);

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    const handleBind = async () => {
        if (!walletName || !address) {
            return Swal.fire(t('error'), t('fill_all_fields'), 'error');
        }

        if (!address.toUpperCase().startsWith('T')) {
            return Swal.fire({
                icon: 'error',
                title: t('invalid_address'),
                text: t('address_must_start_with_t'),
                confirmButtonColor: '#f3ba2f'
            });
        }

        try {
            await set(ref(db, `users/${savedUser.username}/paymentMethod`), {
                walletName: walletName,
                address: address,
                network: 'TRC-20',
                boundAt: new Date().toISOString()
            });
            
            Swal.fire({
                icon: 'success',
                title: t('wallet_bound'),
                text: t('withdrawal_address_locked'),
                timer: 2000,
                showConfirmButton: false
            });
        } catch (error) {
            Swal.fire(t('error'), error.message, 'error');
        }
    };

    if (loading) return <div className="loading-simple">{t('loading')}</div>;

    return (
        <div className="payment-method-wrapper">
            <div className="pm-nav">
                <MdArrowBack onClick={handleBack} className="nav-icon" />
                <span>{t('payment_method')}</span>
                <div className="nav-spacer"></div>
            </div>

            <div className="pm-container">
                <div className="pm-info-card">
                    <MdSecurity size={40} color="#f3ba2f" />
                    <h4>{t('secure_your_withdrawals')}</h4>
                    <p>{t('security_note_text')}</p>
                </div>

                <div className="pm-form">
                    <div className="pm-input-group">
                        <label>{t('wallet_name')}</label>
                        <input 
                            type="text" 
                            placeholder={t('wallet_name_placeholder')} 
                            value={walletName}
                            onChange={(e) => setWalletName(e.target.value)}
                            disabled={isBound}
                        />
                    </div>

                    <div className="pm-input-group">
                        <label>{t('network_fixed')}</label>
                        <div className="fixed-network">TRC-20</div>
                    </div>

                    <div className="pm-input-group">
                        <label>{t('trc20_address')}</label>
                        <input 
                            type="text" 
                            placeholder={t('address_placeholder')} 
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            disabled={isBound}
                        />
                    </div>

                    {!isBound ? (
                        <button className="pm-confirm-btn" onClick={handleBind}>
                            {t('confirm_binding')}
                        </button>
                    ) : (
                        <div className="bound-status">
                            <MdCheckCircle size={20} />
                            {t('wallet_bound_successfully')}
                        </div>
                    )}
                </div>

                <div className="pm-notes">
                    <h5>{t('important')}</h5>
                    <ul>
                        <li>{t('note_verify')}</li>
                        <li>{t('note_trc20_start')}</li>
                        <li>{t('note_contact_support')}</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PaymentMethod;